module.exports = __webpack_public_path__ + "img/vuejs-plugin-guide.17e92aab.png";